/**
 * handles top button visibility
 * handles teaser form position
 */
import throttle from 'lodash/throttle';

export default class WaypointObserver {
    constructor() {
        this.waypoint = document.querySelector('[data-waypoint-top]');
        this.topButton = document.querySelector('[data-jump-top]');
        this.teaserElement = document.querySelector('[data-sticky-teaser-form]');
        this.teaserBackground = document.querySelector('.teaser-background');
        this.teaserBackgroundFixedCssClass = 'fixed';
        this.teaserFormFixedCssClass = 'teaser-form-wrapper--fixed';
        this.topButtonShow = 'jump-to-top--show';
        this.scrollingUp = false;
        this.init();
    }

    init() {
        if (typeof IntersectionObserver === typeof undefined || !this.waypoint) {
            return false;
        }

        if ((!this.teaserElement || !this.teaserBackground) && !this.topButton) {
            return false;
        }

        this.oldScroll = 0;
        if (this.topButton) {
            this.topButton.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
            window.addEventListener('scroll', throttle(this.handleWindowScroll.bind(this), 50));
        }

        const self = this;

        const observer = new IntersectionObserver(([entry]) => {
            self.toggleClass(this.teaserElement, this.teaserFormFixedCssClass, entry.isIntersecting);
            self.toggleClass(this.teaserBackground, this.teaserBackgroundFixedCssClass, entry.isIntersecting);
        });

        observer.observe(this.waypoint);
    }

    handleWindowScroll() {
        const show = this.shouldShowBackToTopBtn(window, this.oldScroll);
        this.topButton.classList.toggle(this.topButtonShow, show);
        this.oldScroll = window.scrollY;
    }

    shouldShowBackToTopBtn(windowObj, oldScroll) {
        /*
        * This should only return true when the user is scrolling up
        * These 2 conditions are necessary to determine the direction the user is scrolling
        * scrollY === oldScroll does not determine whether the user is scrolling up/down
        */
        if (windowObj.scrollY > oldScroll) this.scrollingUp = false;
        if (windowObj.scrollY < oldScroll) this.scrollingUp = true;
        return windowObj.scrollY > windowObj.innerHeight && this.scrollingUp;
    }

    toggleClass(element, className, isIntersecting) {
        if (!element) {
            return false;
        }
        if (!isIntersecting) {
            element.classList.add(className);
        } else {
            element.classList.remove(className);
        }
    }
}
